export default "__VITE_ASSET__C0c6jwmq__"